import { useCreateUserMutation, useEditUserMutation } from "services";
import { useSnackbar } from "notistack";
import { getModifiedFields } from "helpers/functions";

// Función que filtra los campos a excluir
const filterFields = (data, excludeFields) => {
  return Object.fromEntries(
    Object.entries(data).filter(([key, value]) => {
      if (excludeFields.includes(key)) {
        if (key === "telefonos" && Array.isArray(value) && value.length === 0) {
          return false; // Excluir el campo "telefono" si es un arreglo vacío
        }
        return !(typeof value === "string" || value === null || value === "");
      }
      return true;
    })
  );
};

export const usePlantillaSubmit = (id, handleClose, oldValues) => {
  const { enqueueSnackbar } = useSnackbar();

  const [createUser] = useCreateUserMutation();
  const [editUser] = useEditUserMutation();

  const handleSubmit = async (values, actions) => {
    const excludeFields = ["telefonos"];

    try {
      if (!id) {
        // Create Mode
        const data = filterFields(values, excludeFields);
        await createUser(data).unwrap();
        enqueueSnackbar("Registro creado con éxito", { variant: "success" });
      } else {
        // Edit Mode
        const modifiedFields = getModifiedFields(oldValues, values);
        if (Object.keys(modifiedFields).length !== 0) {
          const data = filterFields(modifiedFields, excludeFields);
          await editUser({ id: id, ...data }).unwrap();
          enqueueSnackbar("Registro editado con éxito", { variant: "success" });
        }
      }

      actions.setSubmitting(false);
      actions.resetForm();
      handleClose();
    } catch (error) {
      console.error(error);
      actions.setSubmitting(false);
      enqueueSnackbar(
        !id ? "Error al crear registro" : "Error al editar registro",
        { variant: "error" }
      );
    }
  };

  return { handleSubmit };
};
